import React, { useMemo, useState } from "react";
import "./Stepped.css";
import close from "../img/close.png";

const WORDS = [
  { id: "w1", text: "get dressed" },
  { id: "w2", text: "eats out" },
  { id: "w3", text: "spends" },
  { id: "w4", text: "rude" },
  { id: "w5", text: "polite" },
];

const SENTENCES = [
  {
    id: "s1",
    textParts: ["This book says British people are usually very ", "."],
    answer: "polite",
  },
  {
    id: "s2",
    textParts: ["Bob ", " a lot of money on electronics."],
    answer: "spends",
  },
  {
    id: "s3",
    textParts: [
      "If you don't want to seem ",
      ", you should know the country's traditions before you go there.",
    ],
    answer: "rude",
  },
  {
    id: "s4",
    textParts: [
      "Laura always prepares her clothes in the evening, it helps her to ",
      " quickly in the morning.",
    ],
    answer: "get dressed",
  },
  {
    id: "s5",
    textParts: [
      "Nick can't cook so when he's hungry he ",
      " in the nearest cafe.",
    ],
    answer: "eats out",
  },
];

const FILL_GAP_QUESTIONS = [
  {
    text: ["I usually have ", " at 2 p.m."],
    answer: "lunch"
  },
  {
    text: ["My grandfather can't read without his ", "."],
    answer: "glasses"
  },
  {
    text: ["Mrs Cooper is Mr Cooper's ", ". They got married last year."],
    answer: "wife"
  },
  {
    text: ["Where is my ", "? My keys, my money, and my phone are there."],
    answer: "bag"
  },
  {
    text: ["I'm Pablo. Nice to ", " you, Claire!"],
    answer: "meet"
  },
];

const MATCH_HALVES_QUESTIONS = [
  { id: '1', left: 'There was such a', right: 'crowd at the concert. Everyone was dancing.' },
  { id: '2', left: 'Be careful with', right: ' that vase! It\'s very expensive.' },
  { id: '3', left: 'I think the underground is the', right: 'fastest way to move around the city.' },
  { id: '4', left: 'Mathew wanted to be sporty so', right: 'he decided to go to the gym.' },
  { id: '5', left: 'Sometimes rich people aren\'t', right: 'happier than poor ones.' },
];

const FILL_GAP_WITH_OPTIONS_QUESTIONS = [
  {
    parts: [
      "Dan often comes to class late and never ",
      { options: ["says", "is saying"], answer: "says" },
      ' "sorry".'
    ]
  },
  {
    parts: [
      "Look! Your cat ",
      { options: ["is coming", "comes"], answer: "is coming" },
      " from you."
    ]
  },
  {
    parts: [
      "Kate, what ",
      { options: ["are you thinking", "do you think"], answer: "do you think" },
      " about it?"
    ]
  },
  {
    parts: [
      "OK, you tried on 10 different coats. ",
      { options: ["Do you like", "Are you liking"], answer: "Do you like" },
      " any of them now?"
    ]
  },
  {
    parts: [
      "My girlfriend often ",
      { options: ["drinks", "is drinking"], answer: "drinks" },
      " coffee before going to bed. Is it strange?"
    ]
  },
  {
    parts: [
      "Your dog is so funny! Wait, I ",
      { options: ["am taking", "take"], answer: "am taking" },
      " my phone. I want to take a picture."
    ]
  }
];

const SENTENCES_2 = [
  {
    id: "s6",
    textParts: ["I need to ", " my teeth before going to bed."],
    answer: "brush",
  },
  {
    id: "s7",
    textParts: ["She loves to ", " books in her free time."],
    answer: "read",
  },
  {
    id: "s8",
    textParts: ["We should ", " the environment by recycling."],
    answer: "protect",
  },
  {
    id: "s9",
    textParts: ["Can you ", " me with this heavy box?"],
    answer: "help",
  },
  {
    id: "s10",
    textParts: ["They always ", " their homework after dinner."],
    answer: "do",
  },
];

const WORDS_2 = [
  { id: "w6", text: "brush" },
  { id: "w7", text: "read" },
  { id: "w8", text: "protect" },
  { id: "w9", text: "help" },
  { id: "w10", text: "do" },
];

const FILL_GAP_QUESTIONS_2 = [
  {
    text: ["The ", " is shining brightly today."],
    answer: "sun"
  },
  {
    text: ["I need to buy some ", " from the grocery store."],
    answer: "milk"
  },
  {
    text: ["She plays the ", " very well."],
    answer: "piano"
  },
  {
    text: ["The ", " is barking at the mailman."],
    answer: "dog"
  },
  {
    text: ["I always drink a cup of ", " in the morning."],
    answer: "coffee"
  },
];

const MATCH_HALVES_QUESTIONS_2 = [
  { id: '6', left: 'My sister wants to become a', right: 'doctor when she grows up.' },
  { id: '7', left: 'Don\'t forget to', right: 'lock the door when you leave.' },
  { id: '8', left: 'I always feel', right: 'tired after working all day.' },
  { id: '9', left: 'The movie was so boring that I', right: 'fell asleep in the cinema.' },
  { id: '10', left: 'We need to arrive at the airport', right: 'at least two hours early.' },
];

const FILL_GAP_WITH_OPTIONS_QUESTIONS_2 = [
  {
    parts: [
      "Sarah ",
      { options: ["doesn't like", "isn't liking"], answer: "doesn't like" },
      " spicy food."
    ]
  },
  {
    parts: [
      "Right now, they ",
      { options: ["are watching", "watch"], answer: "are watching" },
      " a movie."
    ]
  },
  {
    parts: [
      "How often ",
      { options: ["do you exercise", "are you exercising"], answer: "do you exercise" },
      "?"
    ]
  },
  {
    parts: [
      "The sun ",
      { options: ["rises", "is rising"], answer: "rises" },
      " in the east every day."
    ]
  },
  {
    parts: [
      "Be quiet! The baby ",
      { options: ["is sleeping", "sleeps"], answer: "is sleeping" },
      " now."
    ]
  },
  {
    parts: [
      "My brother ",
      { options: ["works", "is working"], answer: "works" },
      " as a teacher at the local school."
    ]
  }
];
export default function Stepped() {
  const wordById = useMemo(
    () => WORDS.reduce((m, w) => ((m[w.id] = w.text), m), {}),
    []
  );
  const wordById2 = useMemo(
    () => WORDS_2.reduce((m, w) => ((m[w.id] = w.text), m), {}),
    []
  );
  const STORAGE_KEY = 'englishTestProgress';

function saveProgress(data) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch (e) {
    console.error('Failed to save progress:', e);
  }
}

function loadProgress() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    return saved ? JSON.parse(saved) : null;
  } catch (e) {
    console.error('Failed to load progress:', e);
    return null;
  }
}

function clearProgress() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.error('Failed to clear progress:', e);
  }
}
  
  // words that are still in the top bank (ids)
  const savedProgress = loadProgress();
  const [bank, setBank] = useState(savedProgress?.bank || WORDS.map((w) => w.id));
  const [placed, setPlaced] = useState(savedProgress?.placed || Array(SENTENCES.length).fill(null));
  const [selectedWord, setSelectedWord] = useState(null);
  const [checked, setChecked] = useState(savedProgress?.checked || false);
  const [showModal, setShowModal] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  
  const [stage, setStage] = useState(savedProgress?.stage || 0);
  
  const [matchLeftOrder, setMatchLeftOrder] = useState(
    savedProgress?.matchLeftOrder || MATCH_HALVES_QUESTIONS.map(q => q.id).sort(() => Math.random() - 0.5)
  );
  const [matchRightOrder, setMatchRightOrder] = useState(
    savedProgress?.matchRightOrder || MATCH_HALVES_QUESTIONS.map(q => q.id).sort(() => Math.random() - 0.5)
  );
  const [matchPairs, setMatchPairs] = useState(savedProgress?.matchPairs || Array(MATCH_HALVES_QUESTIONS.length).fill(null));
  const [matchSelectedLeft, setMatchSelectedLeft] = useState(null);
  const [matchChecked, setMatchChecked] = useState(savedProgress?.matchChecked || false);

  const [gapAnswers, setGapAnswers] = useState(savedProgress?.gapAnswers || Array(FILL_GAP_QUESTIONS.length).fill(""));
  const [gapChecked, setGapChecked] = useState(savedProgress?.gapChecked || false);

  const [fgwoAnswers, setFgwoAnswers] = useState(savedProgress?.fgwoAnswers || Array(FILL_GAP_WITH_OPTIONS_QUESTIONS.length).fill(null).map((_, i) => {
    const n_opts = FILL_GAP_WITH_OPTIONS_QUESTIONS[i].parts.filter(p => typeof p === 'object').length;
    return Array(n_opts).fill('');
  }));
  const [fgwoChecked, setFgwoChecked] = useState(savedProgress?.fgwoChecked || false);

  const [bank2, setBank2] = useState(savedProgress?.bank2 || WORDS_2.map((w) => w.id));
  const [placed2, setPlaced2] = useState(savedProgress?.placed2 || Array(SENTENCES_2.length).fill(null));
  const [checked2, setChecked2] = useState(savedProgress?.checked2 || false);

  const [gapAnswers2, setGapAnswers2] = useState(savedProgress?.gapAnswers2 || Array(FILL_GAP_QUESTIONS_2.length).fill(""));
  const [gapChecked2, setGapChecked2] = useState(savedProgress?.gapChecked2 || false);

  const [matchLeftOrder2, setMatchLeftOrder2] = useState(
    savedProgress?.matchLeftOrder2 || MATCH_HALVES_QUESTIONS_2.map(q => q.id).sort(() => Math.random() - 0.5)
  );
  const [matchRightOrder2, setMatchRightOrder2] = useState(
    savedProgress?.matchRightOrder2 || MATCH_HALVES_QUESTIONS_2.map(q => q.id).sort(() => Math.random() - 0.5)
  );
  const [matchPairs2, setMatchPairs2] = useState(savedProgress?.matchPairs2 || Array(MATCH_HALVES_QUESTIONS_2.length).fill(null));
  const [matchSelectedLeft2, setMatchSelectedLeft2] = useState(null);
  const [matchChecked2, setMatchChecked2] = useState(savedProgress?.matchChecked2 || false);
  const [showResults, setShowResults] = useState(false);

  const [fgwoAnswers2, setFgwoAnswers2] = useState(savedProgress?.fgwoAnswers2 || Array(FILL_GAP_WITH_OPTIONS_QUESTIONS_2.length).fill(null).map((_, i) => {
    const n_opts = FILL_GAP_WITH_OPTIONS_QUESTIONS_2[i].parts.filter(p => typeof p === 'object').length;
    return Array(n_opts).fill('');
  }));
  const [fgwoChecked2, setFgwoChecked2] = useState(savedProgress?.fgwoChecked2 || false);
  React.useEffect(() => {
    const progressData = {
      stage,
      bank,
      placed,
      checked,
      matchLeftOrder,
      matchRightOrder,
      matchPairs,
      matchChecked,
      gapAnswers,
      gapChecked,
      fgwoAnswers,
      fgwoChecked,
      bank2,
      placed2,
      checked2,
      gapAnswers2,
      gapChecked2,
      matchLeftOrder2,
      matchRightOrder2,
      matchPairs2,
      matchChecked2,
      fgwoAnswers2,
      fgwoChecked2,
    };
    saveProgress(progressData);
  }, [
    stage, bank, placed, checked, matchLeftOrder, matchRightOrder, matchPairs, matchChecked,
    gapAnswers, gapChecked, fgwoAnswers, fgwoChecked,
    bank2, placed2, checked2, gapAnswers2, gapChecked2,
    matchLeftOrder2, matchRightOrder2, matchPairs2, matchChecked2, fgwoAnswers2, fgwoChecked2
  ]);
  function handleFinalComplete() {
    setShowModal(true);
  }
  function formatPhoneNumber(value) {
    // Remove all non-digits
    const digits = value.replace(/\D/g, '');
    
    // Ensure it starts with 7
    let formatted = '+7';
    
    if (digits.length > 1) {
      // Add first 3 digits (700-800 range)
      const firstThree = digits.slice(1, 4);
      if (firstThree.length > 0) {
        formatted += ' ' + firstThree;
      }
      
      // Add next 3 digits
      if (digits.length > 4) {
        formatted += ' ' + digits.slice(4, 7);
      }
      
      // Add next 2 digits
      if (digits.length > 7) {
        formatted += ' ' + digits.slice(7, 9);
      }
      
      // Add last 2 digits
      if (digits.length > 9) {
        formatted += ' ' + digits.slice(9, 11);
      }
    }
    
    return formatted;
  }
  
  function validatePhoneNumber(phone) {
    // Remove all non-digits
    const digits = phone.replace(/\D/g, '');
    
    // Must have exactly 11 digits (1 for country code + 10 for number)
    if (digits.length !== 11) {
      return { valid: false, error: "Номер должен содержать 11 цифр" };
    }
    
    // Must start with 7
    if (!digits.startsWith('7')) {
      return { valid: false, error: "Номер должен начинаться с +7" };
    }
    
    // Extract operator code (700-800)
    const operatorCode = parseInt(digits.slice(1, 4));
    if (operatorCode < 700 || operatorCode > 800) {
      return { valid: false, error: "Код оператора должен быть в диапазоне 700-800" };
    }
    
    return { valid: true, error: null };
  }
  function handlePhoneNumberChange(e) {
    const formatted = formatPhoneNumber(e.target.value);
    setPhoneNumber(formatted);
    setSubmitError(""); // Clear error when user types
  }
  async function handlePhoneSubmit(e) {
    e.preventDefault();

    // Basic phone validation
    const validation = validatePhoneNumber(phoneNumber);
    if (!validation.valid) {
      setSubmitError(validation.error);
      return;
    }

    setIsSubmitting(true);
    setSubmitError("");

    try {
      // Replace with your Google Sheets Web App URL
      const GOOGLE_SHEETS_URL = 'https://script.google.com/macros/s/AKfycbxwnaMwrkAhz_ZvdPTZE7MUhDvuaQTH5QepXdxtKaHjlCgIK6MpeeoKYqYsMKajE3z8gg/exec';

      const response = await fetch(GOOGLE_SHEETS_URL, {
        method: 'POST',
        mode: 'no-cors',
        headers: {
          'Content-Type': 'application/json',
        },  
        body: JSON.stringify({
          timestamp: new Date().toISOString(),
          phone: phoneNumber,
          result: `${TOTAL_CORRECT}/${TOTAL_MAX}`,
          accuracy: `${ACCURACY}%`,
          level: ENGLISH_LEVEL,
        })
      });
      clearProgress();
      setShowModal(false);
      setShowResults(true);
    } catch (error) {
      console.error('Ошибка при отправке:', error);
      setSubmitError("Не удалось отправить заявку. Пожалуйста, попробуйте снова.");
    } finally {
      setIsSubmitting(false);
    }
  }
  function handleRestartTest() {
    setShowResults(false);
    clearProgress();
    // Reset all states
    setStage(0);
    setBank(WORDS.map((w) => w.id));
    setPlaced(Array(SENTENCES.length).fill(null));
    setSelectedWord(null);
    setChecked(false);
    setGapAnswers(Array(FILL_GAP_QUESTIONS.length).fill(""));
    setGapChecked(false);
    setMatchPairs(Array(MATCH_HALVES_QUESTIONS.length).fill(null));
    setMatchChecked(false);
    setFgwoAnswers(FILL_GAP_WITH_OPTIONS_QUESTIONS.map(q => q.parts.filter(p => typeof p === 'object').map(() => '')));
    setFgwoChecked(false);
    setBank2(WORDS_2.map((w) => w.id));
    setPlaced2(Array(SENTENCES_2.length).fill(null));
    setChecked2(false);
    setGapAnswers2(Array(FILL_GAP_QUESTIONS_2.length).fill(""));
    setGapChecked2(false);
    setMatchPairs2(Array(MATCH_HALVES_QUESTIONS_2.length).fill(null));
    setMatchChecked2(false);
    setFgwoAnswers2(FILL_GAP_WITH_OPTIONS_QUESTIONS_2.map(q => q.parts.filter(p => typeof p === 'object').map(() => '')));
    setFgwoChecked2(false);
    setPhoneNumber("");
  }
  function handleModalClose() {
    if (!isSubmitting) {
      setShowModal(false);
      setPhoneNumber("");
      setSubmitError("");
    }
  }
  // Add wordById2 after wordById

  const score2 = placed2.reduce((acc, wid, i) => {
    if (!wid) return acc;
    return acc + (wordById2[wid] === SENTENCES_2[i].answer ? 1 : 0);
  }, 0);

  const gapScore2 = gapAnswers2.reduce(
    (acc, ans, i) => acc + (ans.trim().toLowerCase() === FILL_GAP_QUESTIONS_2[i].answer ? 1 : 0),
    0
  );

  const matchScore2 = matchPairs2.reduce(
    (acc, rid, lidx) =>
      acc + (rid !== null && matchLeftOrder2[lidx] === matchRightOrder2[rid] ? 1 : 0),
    0
  );

  const fgwoScore2 = fgwoAnswers2.reduce((acc, arr, qIdx) => {
    const opts = FILL_GAP_WITH_OPTIONS_QUESTIONS_2[qIdx].parts.filter(p => typeof p === 'object');
    return acc + arr.reduce((sum, ans, oI) => sum + (ans === opts[oI].answer ? 1 : 0), 0);
  }, 0);
  const fgwoMax2 = FILL_GAP_WITH_OPTIONS_QUESTIONS_2.reduce((a, q) => a + q.parts.filter(p => typeof p === 'object').length, 0);

  const score = placed.reduce((acc, wid, i) => {
    if (!wid) return acc;
    return acc + (wordById[wid] === SENTENCES[i].answer ? 1 : 0);
  }, 0);

  const gapScore = gapAnswers.reduce(
    (acc, ans, i) => acc + (ans.trim().toLowerCase() === FILL_GAP_QUESTIONS[i].answer ? 1 : 0),
    0
  );

  const matchScore = matchPairs.reduce(
    (acc, rid, lidx) =>
      acc + (rid !== null && matchLeftOrder[lidx] === matchRightOrder[rid] ? 1 : 0),
    0
  );

  const fgwoScore = fgwoAnswers.reduce((acc, arr, qIdx) => {
    const opts = FILL_GAP_WITH_OPTIONS_QUESTIONS[qIdx].parts.filter(p => typeof p === 'object');
    return acc + arr.reduce((sum, ans, oI) => sum + (ans === opts[oI].answer ? 1 : 0), 0);
  }, 0);
  const fgwoMax = FILL_GAP_WITH_OPTIONS_QUESTIONS.reduce((a, q) => a + q.parts.filter(p => typeof p === 'object').length, 0);
  const TOTAL_CORRECT = score + gapScore + matchScore + fgwoScore + score2 + gapScore2 + matchScore2 + fgwoScore2;
  const TOTAL_MAX = SENTENCES.length + FILL_GAP_QUESTIONS.length + MATCH_HALVES_QUESTIONS.length + fgwoMax +
    SENTENCES_2.length + FILL_GAP_QUESTIONS_2.length + MATCH_HALVES_QUESTIONS_2.length + fgwoMax2;
  const ACCURACY = TOTAL_MAX > 0 ? Math.round((TOTAL_CORRECT / TOTAL_MAX) * 100) : 0;

  // Top-level constants for 'level', etc.
  const accuracyRatio = TOTAL_CORRECT / TOTAL_MAX;

  let ENGLISH_LEVEL = '';
  if (accuracyRatio < 0.25) ENGLISH_LEVEL = 'A1';
  else if (accuracyRatio < 0.45) ENGLISH_LEVEL = 'A2';
  else if (accuracyRatio < 0.65) ENGLISH_LEVEL = 'B1';
  else if (accuracyRatio < 0.80) ENGLISH_LEVEL = 'B2';
  else if (accuracyRatio < 0.90) ENGLISH_LEVEL = 'C1';
  else ENGLISH_LEVEL = 'C2';

  // Helper: calculate totals
  function handleGoNextFromFgwo() {
    setStage(4);
    setChecked2(false);
  }

  function handleGoNextFromSentences2() {
    setStage(5);
    setGapChecked2(false);
  }

  function handleGoNextFromGap2() {
    setStage(6);
    setMatchChecked2(false);
  }

  function handleGoNextFromHalves2() {
    setStage(7);
    setFgwoChecked2(false);
  }

  // Handlers for Set 2 Drag-and-drop
  function handleDropToBlank2(idx, wid) {
    setPlaced2((prev) => {
      const next = [...prev];
      if (next[idx]) setBank2((b) => [...b, next[idx]]);
      next[idx] = wid;
      return next;
    });
    setBank2((b) => b.filter((id) => id !== wid));
    setSelectedWord(null);
  }

  function handleDropToBank2(wid) {
    setPlaced2((prev) => {
      const next = prev.map((v) => (v === wid ? null : v));
      return next;
    });
    setBank2((b) => (b.includes(wid) ? b : [...b, wid]));
    setSelectedWord(null);
  }

  function onBlankDrop2(e, idx) {
    e.preventDefault();
    const wid = e.dataTransfer.getData("text/plain");
    if (!wid) return;
    if (!bank2.includes(wid)) {
      const fromIdx = placed2.findIndex((p) => p === wid);
      if (fromIdx !== -1) {
        setPlaced2((prev) => {
          const next = [...prev];
          const tmp = next[idx];
          next[idx] = wid;
          next[fromIdx] = tmp || null;
          return next;
        });
        return;
      }
    }
    handleDropToBlank2(idx, wid);
  }

  function onBankDrop2(e) {
    e.preventDefault();
    const wid = e.dataTransfer.getData("text/plain");
    if (!wid) return;
    handleDropToBank2(wid);
  }

  function resetAll2() {
    setBank2(WORDS_2.map((w) => w.id));
    setPlaced2(Array(SENTENCES_2.length).fill(null));
    setSelectedWord(null);
    setChecked2(false);
  }

  function checkAnswers2() {
    setChecked2(true);
  }

  function handleBlankClick2(idx) {
    if (!selectedWord) return;
    handleDropToBlank2(idx, selectedWord);
  }

  // Handlers for Set 2 Gap filling
  function handleGapInput2(idx, value) {
    setGapAnswers2((prev) => {
      const next = [...prev];
      next[idx] = value;
      return next;
    });
  }

  function handleGapCheck2() {
    setGapChecked2(true);
  }

  function handleGapReset2() {
    setGapAnswers2(Array(FILL_GAP_QUESTIONS_2.length).fill(""));
    setGapChecked2(false);
  }

  // Handlers for Set 2 Match halves
  function handleMatchSelectLeft2(lidx) {
    setMatchSelectedLeft2(lidx);
  }

  function handleMatchSelectRight2(ridx) {
    if (matchSelectedLeft2 === null) return;
    setMatchPairs2(prev => {
      const next = [...prev];
      next[matchSelectedLeft2] = ridx;
      return next;
    });
    setMatchSelectedLeft2(null);
  }

  function handleMatchCheck2() {
    setMatchChecked2(true);
  }

  function handleMatchReset2() {
    setMatchPairs2(Array(MATCH_HALVES_QUESTIONS_2.length).fill(null));
    setMatchChecked2(false);
    setMatchSelectedLeft2(null);
  }

  // Handlers for Set 2 Fill-Gap-With-Options
  function handleFgwoSelect2(qIdx, optIdx, value) {
    setFgwoAnswers2(prev => {
      const next = prev.map((arr, i) => arr.slice());
      next[qIdx][optIdx] = value;
      return next;
    });
  }

  function handleFgwoCheck2() {
    setFgwoChecked2(true);
  }

  function handleFgwoReset2() {
    setFgwoAnswers2(FILL_GAP_WITH_OPTIONS_QUESTIONS_2.map(q => q.parts.filter(p => typeof p === 'object').map(() => '')));
    setFgwoChecked2(false);
  }
  function handleDropToBlank(idx, wid) {
    setPlaced((prev) => {
      const next = [...prev];
      // if blank already occupied, return that word to the bank
      if (next[idx]) setBank((b) => [...b, next[idx]]);
      next[idx] = wid;
      return next;
    });
    // remove from bank
    setBank((b) => b.filter((id) => id !== wid));
    setSelectedWord(null);
  }

  function handleDropToBank(wid) {
    // find and clear from any blank
    setPlaced((prev) => {
      const next = prev.map((v) => (v === wid ? null : v));
      return next;
    });
    // add back to bank if not already there
    setBank((b) => (b.includes(wid) ? b : [...b, wid]));
    setSelectedWord(null);
  }

  function onDragStart(e, wid) {
    e.dataTransfer.setData("text/plain", wid);
    e.dataTransfer.effectAllowed = "move";
  }

  function onBlankDrop(e, idx) {
    e.preventDefault();
    const wid = e.dataTransfer.getData("text/plain");
    if (!wid) return;
    if (!bank.includes(wid)) {
      // dragged from another blank; swap
      const fromIdx = placed.findIndex((p) => p === wid);
      if (fromIdx !== -1) {
        setPlaced((prev) => {
          const next = [...prev];
          const tmp = next[idx];
          next[idx] = wid;
          next[fromIdx] = tmp || null;
          return next;
        });
        return;
      }
    }
    handleDropToBlank(idx, wid);
  }

  function onBankDrop(e) {
    e.preventDefault();
    const wid = e.dataTransfer.getData("text/plain");
    if (!wid) return;
    handleDropToBank(wid);
  }

  function handleGapInput(idx, value) {
    setGapAnswers((prev) => {
      const next = [...prev];
      next[idx] = value;
      return next;
    });
  }
  function handleGapCheck() {
    setGapChecked(true);
  }
  function handleGapReset() {
    setGapAnswers(Array(FILL_GAP_QUESTIONS.length).fill(""));
    setGapChecked(false);
  }
  function handleGoNext() {
    // From drag-and-drop to text-gaps
    setStage(1);
    setGapChecked(false);
  }

  function handleMatchSelectLeft(lidx) {
    setMatchSelectedLeft(lidx);
  }
  function handleMatchSelectRight(ridx) {
    if (matchSelectedLeft === null) return;
    setMatchPairs(prev => {
      const next = [...prev];
      next[matchSelectedLeft] = ridx;
      return next;
    });
    setMatchSelectedLeft(null);
  }
  function handleMatchCheck() {
    setMatchChecked(true);
  }
  function handleMatchReset() {
    setMatchPairs(Array(MATCH_HALVES_QUESTIONS.length).fill(null));
    setMatchChecked(false);
    setMatchSelectedLeft(null);
  }
  function handleGoNextFromGap() {
    setStage(2);
    setMatchChecked(false);
  }

  function handleFgwoSelect(qIdx, optIdx, value) {
    setFgwoAnswers(prev => {
      const next = prev.map((arr, i) => arr.slice());
      next[qIdx][optIdx] = value;
      return next;
    });
  }
  function handleFgwoCheck() {
    setFgwoChecked(true);
  }
  function handleFgwoReset() {
    setFgwoAnswers(FILL_GAP_WITH_OPTIONS_QUESTIONS.map(q => q.parts.filter(p => typeof p === 'object').map(() => '')));
    setFgwoChecked(false);
  }
  function handleGoNextFromHalves() {
    setStage(3);
    setFgwoChecked(false);
  }

  function resetAll() {
    setBank(WORDS.map((w) => w.id));
    setPlaced(Array(SENTENCES.length).fill(null));
    setSelectedWord(null);
    setChecked(false);
  }

  function checkAnswers() {
    setChecked(true);
  }

  // click-to-fill (mobile-friendly): select word then tap a blank
  function handleWordClick(wid) {
    setSelectedWord((cur) => (cur === wid ? null : wid));
  }

  function handleBlankClick(idx) {
    if (!selectedWord) return;
    handleDropToBlank(idx, selectedWord);
  }
  // Auto-check Stage 0 (drag-and-drop)
  React.useEffect(() => {
    if (stage === 0 && placed.every(p => p !== null)) {
      setChecked(true);
    }
  }, [placed, stage]);

  // Auto-check Stage 1 (fill gaps)
  React.useEffect(() => {
    if (stage === 1 && gapAnswers.every(ans => ans.trim() !== '')) {
      const timer = setTimeout(() => {
        setGapChecked(true);
      }, 5000); // 500ms delay after last keystroke
      return () => clearTimeout(timer);
    }
  }, [gapAnswers, stage]);

  // Auto-check Stage 2 (match halves)
  React.useEffect(() => {
    if (stage === 2 && matchPairs.every(p => p !== null)) {
      setMatchChecked(true);
    }
  }, [matchPairs, stage]);

  // Auto-check Stage 3 (fill with options)
  React.useEffect(() => {
    if (stage === 3 && fgwoAnswers.every(arr => arr.every(a => a !== ''))) {
      setFgwoChecked(true);
    }
  }, [fgwoAnswers, stage]);

  // Auto-check Stage 4 (drag-and-drop set 2)
  React.useEffect(() => {
    if (stage === 4 && placed2.every(p => p !== null)) {
      setChecked2(true);
    }
  }, [placed2, stage]);

  // Auto-check Stage 5 (fill gaps set 2)
  React.useEffect(() => {
    if (stage === 5 && gapAnswers2.every(ans => ans.trim() !== '')) {
      const timer = setTimeout(() => {
        setGapChecked2(true);
      }, 5000); // 500ms delay after last keystroke
      return () => clearTimeout(timer);
    }
  }, [gapAnswers2, stage]);

  // Auto-check Stage 6 (match halves set 2)
  React.useEffect(() => {
    if (stage === 6 && matchPairs2.every(p => p !== null)) {
      setMatchChecked2(true);
    }
  }, [matchPairs2, stage]);

  // Auto-check Stage 7 (fill with options set 2)
  React.useEffect(() => {
    if (stage === 7 && fgwoAnswers2.every(arr => arr.every(a => a !== ''))) {
      setFgwoChecked2(true);
    }
  }, [fgwoAnswers2, stage]);
  return (
    <div className="app">
      <header className="brand">
        <div className="logoDot" />
        <span>English Level Test</span>
      </header>

      <div className="main-content">
        <div className="progress-parent">
          <div className="level-progress-box">
            <div className="lpb-title-group">
              <span className="lpb-level-header">Test Progress</span>
              <div className="lpb-level-name">{Math.round((stage / 7) * 100)}%</div>
            </div>
            <div className="lpb-bar-group">
              <div className="lpb-bar-bg">
                <div
                  className="lpb-bar-fill"
                  style={{ width: `${(stage / 7) * 100}%` }}
                />
              </div>
            </div>
            <div className="lpb-stats-row">
              <div className="lpb-stat-acc">
                <span className="lpb-stat-label">Completed</span>
                <span className="lpb-stat-value">{stage}/8</span>
              </div>
              <div className="lpb-stat-score">
                <span className="lpb-stat-label">Stage</span>
                <span className="lpb-stat-value">{stage + 1}</span>
              </div>
            </div>
          </div>
        </div>

        <main className="card">
        {showResults ? (
  <div className="results-page">
    <div className="results-header">
      <h2 className="title">Results</h2>
      <p className="results-subtitle">Congratulations on completing the test!</p>
    </div>
    
    <div className="results-stats">
      <div className="result-stat-card">
        <div className="result-stat-label">Correct answers</div>
        <div className="result-stat-value">{TOTAL_CORRECT} / {TOTAL_MAX}</div>
      </div>
      
      <div className="result-stat-card">
        <div className="result-stat-label">Accuracy</div>
        <div className="result-stat-value result-stat-value--accent">{ACCURACY}%</div>
      </div>
      
      <div className="result-stat-card result-stat-card--highlight">
        <div className="result-stat-label">Your level</div>
        <div className="result-stat-value result-stat-value--large">{ENGLISH_LEVEL}</div>
      </div>
    </div>
    
    <div className="results-breakdown">
      <h3 className="results-breakdown-title">Detailed information</h3>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Completing sentences (dragging and dropping)</span>
        <span className="breakdown-score">{score}/{SENTENCES.length}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Filling in gaps (entering text)</span>
        <span className="breakdown-score">{gapScore}/{FILL_GAP_QUESTIONS.length}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Connecting the halves</span>
        <span className="breakdown-score">{matchScore}/{MATCH_HALVES_QUESTIONS.length}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Choosing the right option</span>
        <span className="breakdown-score">{fgwoScore}/{fgwoMax}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Completion of sentences 2 (drag and drop)</span>
        <span className="breakdown-score">{score2}/{SENTENCES_2.length}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Filling in gaps 2 (text entry)</span>
        <span className="breakdown-score">{gapScore2}/{FILL_GAP_QUESTIONS_2.length}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Connecting the halves 2</span>
        <span className="breakdown-score">{matchScore2}/{MATCH_HALVES_QUESTIONS_2.length}</span>
      </div>
      
      <div className="breakdown-item">
        <span className="breakdown-label">Choosing the right option 2</span>
        <span className="breakdown-score">{fgwoScore2}/{fgwoMax2}</span>
      </div>
    </div>
    
    <div className="results-message">
      <p>Great job! We will contact you soon to discuss the next steps.</p>
    </div>
    
    <div className="actions">
      <button className="btn" onClick={handleRestartTest}>
      Pass test again      
      </button>
    </div>
  </div>
) : (
  <>
          {/* -- Step 0: Drag-and-drop -- */}
          {stage === 0 && (
            <>
              <div className="header-card">
                <h2 className="title">Complete the sentences</h2>
                {matchChecked && (
                  <div className="score" aria-live="polite">Score: {matchScore} / {SENTENCES.length}</div>
                )}
              </div>
              {/* Word bank */}
              <div
                className="bank"
                onDragOver={(e) => e.preventDefault()}
                onDrop={onBankDrop}
              >
                {WORDS.sort((a, b) => a.text.localeCompare(b.text)).map(
                  ({ id, text }) => {
                    const isUsed = placed.includes(id);
                    return (
                      <button
                        key={id}
                        className={
                          "token" +
                          (selectedWord === id ? " token--selected" : "") +
                          (isUsed ? " token--disabled" : "")
                        }
                        draggable={!isUsed}
                        disabled={isUsed}
                        onDragStart={(e) => !isUsed && onDragStart(e, id)}
                        onClick={() => !isUsed && handleWordClick(id)}
                        aria-label={`Answer option: ${text}`}
                      >
                        {text}
                      </button>
                    );
                  }
                )}
              </div>

              {/* Sentences */}
              <ol className="sentences">
                {SENTENCES.map((s, idx) => {
                  const wid = placed[idx];
                  const isCorrect = checked && wid && wordById[wid] === s.answer;
                  const isWrong = checked && wid && wordById[wid] !== s.answer;
                  return (
                    <li key={s.id} className="sentenceRow">
                      <span className="before">{s.textParts[0]}</span>

                      <span
                        className={
                          "blank" +
                          (isCorrect ? " blank--correct" : "") +
                          (isWrong ? " blank--wrong" : "") +
                          (!wid ? " blank--empty" : "")
                        }
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => onBlankDrop(e, idx)}
                        onClick={() => handleBlankClick(idx)}
                        role="button"
                        tabIndex={0}
                      >
                        {wid ? (
                          <span
                            className="filledToken"
                            draggable
                            onDragStart={(e) => onDragStart(e, wid)}
                            title="Drag back to the bank or click × to remove"
                          >
                            {wordById[wid]}
                            <button
                              className="remove"
                              aria-label="Remove"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDropToBank(wid);
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </span>
                        ) : (
                          <span className="placeholder"></span>
                        )}
                      </span>

                      <span className="after">{s.textParts[1]}</span>
                    </li>
                  );
                })}
              </ol>

              {/* Footer for stage 0 */}
              <div className="actions">
                <button className="btn btn--ghost" onClick={resetAll}>Reset</button>
                {checked && (
                  <button className="next-button" onClick={handleGoNext}>NEXT</button>
                )}
              </div>
            </>
          )}
          {/* -- Step 1: Fill-the-gap text -- */}
          {stage === 1 && (

            <>
              <div className="header-card">
                <h2 className="title">Complete the sentences (Type your answers)</h2>
                {matchChecked && (
                  <div className="score" aria-live="polite">Score: {matchScore} / {FILL_GAP_QUESTIONS.length}</div>
                )}
              </div>
              <ol className="sentences fillgap">
                {FILL_GAP_QUESTIONS.map((q, i) => {
                  const ans = gapAnswers[i];
                  const isCorrect = gapChecked && ans.trim().toLowerCase() === q.answer;
                  const isWrong = gapChecked && ans && !isCorrect;
                  return (
                    <li key={i} className="sentenceRow">
                      <span className="before">{q.text[0]}</span>
                      <input
                        className={
                          "gap-input" +
                          (isCorrect ? " gap-input--correct" : "") +
                          (isWrong ? " gap-input--wrong" : "")
                        }
                        type="text"
                        value={ans}
                        disabled={gapChecked}
                        onChange={e => handleGapInput(i, e.target.value)}
                        aria-label={`Type the answer`}
                      />
                      <span className="after">{q.text[1]}</span>
                    </li>
                  );
                })}
              </ol>
              <div className="actions">
                <button className="btn btn--ghost" onClick={handleGapReset}>Reset</button>
                {gapChecked && (
                  <button className="next-button" onClick={handleGoNextFromGap}>NEXT</button>
                )}
              </div>
            </>
          )}
          {/* -- Step 2: Match Halves -- */}
          {stage === 2 && (
            <>
              <div className="header-card">
                <h2 className="title">Match the halves of the sentences</h2>
                {matchChecked && (
                  <div className="score" aria-live="polite">Score: {matchScore} / {MATCH_HALVES_QUESTIONS.length}</div>
                )}
              </div>
              <div className="match-halves-grid">
                <div className="match-column match-column--left">
                  {matchLeftOrder.map((lid, lidx) => {
                    const question = MATCH_HALVES_QUESTIONS.find(q => q.id === lid);
                    const selected = matchSelectedLeft === lidx;
                    const isUsed = matchPairs[lidx] !== null;
                    return (
                      <div
                        key={lid}
                        className={
                          'match-item' +
                          (selected ? ' match-item--selected' : '') +
                          (isUsed ? ' match-item--used' : '') +
                          (matchChecked && isUsed && lid === matchRightOrder[matchPairs[lidx]]
                            ? ' match-item--correct'
                            : matchChecked && isUsed
                              ? ' match-item--wrong'
                              : '')
                        }
                        onClick={() => !isUsed && handleMatchSelectLeft(lidx)}
                        role="button"
                        tabIndex={0}
                        aria-disabled={isUsed}
                      >
                        {question.left}
                      </div>
                    );
                  })}
                </div>
                <div className="match-column match-column--right">
                  {matchRightOrder.map((rid, ridx) => {
                    const question = MATCH_HALVES_QUESTIONS.find(q => q.id === rid);
                    const isMatched = matchPairs.includes(ridx);
                    return (
                      <div
                        key={rid}
                        className={'match-item' + (isMatched ? ' match-item--used' : '')}
                        onClick={() => !isMatched && handleMatchSelectRight(ridx)}
                        role="button"
                        tabIndex={0}
                        aria-disabled={isMatched}
                      >
                        {question.right}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="actions">
                <button className="btn btn--ghost" onClick={handleMatchReset}>Reset</button>
                {matchChecked && (
                  <button className="next-button" onClick={handleGoNextFromHalves}>NEXT</button>
                )}
              </div>
            </>
          )}
          {/* -- Step 3: Fill-Gap-With-Options -- */}
          {stage === 3 && (
            <>
              <div className="header-card">
                <h2 className="title">Complete the sentences</h2>
                {matchChecked && (
                  <div className="score" aria-live="polite">Score: {matchScore} / {FILL_GAP_WITH_OPTIONS_QUESTIONS.length}</div>
                )}
              </div>
              <ol className="sentences">
                {FILL_GAP_WITH_OPTIONS_QUESTIONS.map((q, qIdx) => {
                  let optIdx = 0;
                  return (
                    <li key={qIdx} className="sentenceRow">
                      {q.parts.map((part, i) => {
                        if (typeof part === 'string') return <span key={i}>{part}</span>;
                        const value = fgwoAnswers[qIdx][optIdx];
                        const correct = fgwoChecked && value === part.answer;
                        const wrong = fgwoChecked && value && value !== part.answer;
                        const options = part.options;
                        const selIdx = optIdx;
                        optIdx++;
                        return (
                          <select
                            key={i}
                            className={'gap-select' + (correct ? ' gap-select--correct' : '') + (wrong ? ' gap-select--wrong' : '')}
                            value={value}
                            onChange={e => handleFgwoSelect(qIdx, selIdx, e.target.value)}
                            disabled={fgwoChecked}
                            aria-label='Choose the correct answer'
                          >
                            <option value="">---</option>
                            {options.map(opt => (
                              <option key={opt} value={opt}>{opt}</option>
                            ))}
                          </select>
                        );
                      })}
                    </li>
                  );
                })}
              </ol>
              <div className="actions">
                <button className="btn btn--ghost" onClick={handleFgwoReset}>Reset</button>
                {fgwoChecked && (
                  <button className="next-button" onClick={handleGoNextFromFgwo}>NEXT</button>
                )}
              </div>
            </>
          )}
          {/* -- Step 4: Drag-and-drop Set 2 -- */}
          {stage === 4 && (
            <>
              <div className="header-card">
                <h2 className="title">Complete the sentences</h2>
                {checked2 && (
                  <div className="score" aria-live="polite">Score: {score2} / {SENTENCES_2.length}</div>
                )}
              </div>
              <div
                className="bank"
                onDragOver={(e) => e.preventDefault()}
                onDrop={onBankDrop2}
              >
                {WORDS_2.sort((a, b) => a.text.localeCompare(b.text)).map(
                  ({ id, text }) => {
                    const isUsed = placed2.includes(id);
                    return (
                      <button
                        key={id}
                        className={
                          "token" +
                          (selectedWord === id ? " token--selected" : "") +
                          (isUsed ? " token--disabled" : "")
                        }
                        draggable={!isUsed}
                        disabled={isUsed}
                        onDragStart={(e) => !isUsed && onDragStart(e, id)}
                        onClick={() => !isUsed && handleWordClick(id)}
                        aria-label={`Answer option: ${text}`}
                      >
                        {text}
                      </button>
                    );
                  }
                )}
              </div>
              <ol className="sentences">
                {SENTENCES_2.map((s, idx) => {
                  const wid = placed2[idx];
                  const isCorrect = checked2 && wid && wordById2[wid] === s.answer;
                  const isWrong = checked2 && wid && wordById2[wid] !== s.answer;
                  return (
                    <li key={s.id} className="sentenceRow">
                      <span className="before">{s.textParts[0]}</span>
                      <span
                        className={
                          "blank" +
                          (isCorrect ? " blank--correct" : "") +
                          (isWrong ? " blank--wrong" : "") +
                          (!wid ? " blank--empty" : "")
                        }
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => onBlankDrop2(e, idx)}
                        onClick={() => handleBlankClick2(idx)}
                        role="button"
                        tabIndex={0}
                      >
                        {wid ? (
                          <span
                            className="filledToken"
                            draggable
                            onDragStart={(e) => onDragStart(e, wid)}
                            title="Drag back to the bank or click × to remove"
                          >
                            {wordById2[wid]}
                            <button
                              className="remove"
                              aria-label="Remove"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleDropToBank2(wid);
                              }}
                            >
                              <img src={close} alt="" />
                            </button>
                          </span>
                        ) : (
                          <span className="placeholder"></span>
                        )}
                      </span>
                      <span className="after">{s.textParts[1]}</span>
                    </li>
                  );
                })}
              </ol>
              <div className="actions">
                <button className="btn btn--ghost" onClick={resetAll2}>Reset</button>
                {checked2 && (
                  <button className="next-button" onClick={handleGoNextFromSentences2}>NEXT</button>
                )}
              </div>
            </>
          )}

          {/* -- Step 5: Fill-the-gap Set 2 -- */}
          {stage === 5 && (
            <>
              <div className="header-card">
                <h2 className="title">Complete the sentences (Type your answers)</h2>
                {gapChecked2 && (
                  <div className="score" aria-live="polite">Score: {gapScore2} / {FILL_GAP_QUESTIONS_2.length}</div>
                )}
              </div>
              <ol className="sentences fillgap">
                {FILL_GAP_QUESTIONS_2.map((q, i) => {
                  const ans = gapAnswers2[i];
                  const isCorrect = gapChecked2 && ans.trim().toLowerCase() === q.answer;
                  const isWrong = gapChecked2 && ans && !isCorrect;
                  return (
                    <li key={i} className="sentenceRow">
                      <span className="before">{q.text[0]}</span>
                      <input
                        className={
                          "gap-input" +
                          (isCorrect ? " gap-input--correct" : "") +
                          (isWrong ? " gap-input--wrong" : "")
                        }
                        type="text"
                        value={ans}
                        disabled={gapChecked2}
                        onChange={e => handleGapInput2(i, e.target.value)}
                        aria-label={`Type the answer`}
                      />
                      <span className="after">{q.text[1]}</span>
                    </li>
                  );
                })}
              </ol>
              <div className="actions">
                <button className="btn btn--ghost" onClick={handleGapReset2}>Reset</button>
                {gapChecked2 && (
                  <button className="next-button" onClick={handleGoNextFromGap2}>NEXT</button>
                )}
              </div>
            </>
          )}

          {/* -- Step 6: Match Halves Set 2 -- */}
          {stage === 6 && (
            <>
              <div className="header-card">
                <h2 className="title">Match the halves of the sentences</h2>
                {matchChecked2 && (
                  <div className="score" aria-live="polite">Score: {matchScore2} / {MATCH_HALVES_QUESTIONS_2.length}</div>
                )}
              </div>
              <div className="match-halves-grid">
                <div className="match-column match-column--left">
                  {matchLeftOrder2.map((lid, lidx) => {
                    const question = MATCH_HALVES_QUESTIONS_2.find(q => q.id === lid);
                    const selected = matchSelectedLeft2 === lidx;
                    const isUsed = matchPairs2[lidx] !== null;
                    return (
                      <div
                        key={lid}
                        className={
                          'match-item' +
                          (selected ? ' match-item--selected' : '') +
                          (isUsed ? ' match-item--used' : '') +
                          (matchChecked2 && isUsed && lid === matchRightOrder2[matchPairs2[lidx]]
                            ? ' match-item--correct'
                            : matchChecked2 && isUsed
                              ? ' match-item--wrong'
                              : '')
                        }
                        onClick={() => !isUsed && handleMatchSelectLeft2(lidx)}
                        role="button"
                        tabIndex={0}
                        aria-disabled={isUsed}
                      >
                        {question.left}
                      </div>
                    );
                  })}
                </div>
                <div className="match-column match-column--right">
                  {matchRightOrder2.map((rid, ridx) => {
                    const question = MATCH_HALVES_QUESTIONS_2.find(q => q.id === rid);
                    const isMatched = matchPairs2.includes(ridx);
                    return (
                      <div
                        key={rid}
                        className={'match-item' + (isMatched ? ' match-item--used' : '')}
                        onClick={() => !isMatched && handleMatchSelectRight2(ridx)}
                        role="button"
                        tabIndex={0}
                        aria-disabled={isMatched}
                      >
                        {question.right}
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="actions">
                <button className="btn btn--ghost" onClick={handleMatchReset2}>Reset</button>
                {matchChecked2 && (
                  <button className="next-button" onClick={handleGoNextFromHalves2}>NEXT</button>
                )}
              </div>
            </>
          )}

          {/* -- Step 7: Fill-Gap-With-Options Set 2 -- */}
          {stage === 7 && (
            <>
              <div className="header-card">
                <h2 className="title">Complete the sentences</h2>
                {fgwoChecked2 && (
                  <div className="score" aria-live="polite">Score: {fgwoScore2} / {fgwoMax2}</div>
                )}
              </div>
              <ol className="sentences">
                {FILL_GAP_WITH_OPTIONS_QUESTIONS_2.map((q, qIdx) => {
                  let optIdx = 0;
                  return (
                    <li key={qIdx} className="sentenceRow">
                      {q.parts.map((part, i) => {
                        if (typeof part === 'string') return <span key={i}>{part}</span>;
                        const value = fgwoAnswers2[qIdx][optIdx];
                        const correct = fgwoChecked2 && value === part.answer;
                        const wrong = fgwoChecked2 && value && value !== part.answer;
                        const options = part.options;
                        const selIdx = optIdx;
                        optIdx++;
                        return (
                          <select
                            key={i}
                            className={'gap-select' + (correct ? ' gap-select--correct' : '') + (wrong ? ' gap-select--wrong' : '')}
                            value={value}
                            onChange={e => handleFgwoSelect2(qIdx, selIdx, e.target.value)}
                            disabled={fgwoChecked2}
                            aria-label='Choose the correct answer'
                          >
                            <option value="">---</option>
                            {options.map(opt => (
                              <option key={opt} value={opt}>{opt}</option>
                            ))}
                          </select>
                        );
                      })}
                    </li>
                  );
                })}
              </ol>
              <div className="actions">
                <button className="btn btn--ghost" onClick={handleFgwoReset2}>Reset</button>
                {fgwoChecked2 && (
                  <button className="next-button" onClick={handleFinalComplete}>Complete Test</button>
                )}
              </div>
            </>
          )}
          </>
          )}
        </main>
      </div>
      {/* Phone Number Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={handleModalClose}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={handleModalClose} disabled={isSubmitting}>
              ×
            </button>

            <div className="modal-header">
              <h2>Ваши результаты:</h2>
              <div className="modal-score-summary" style={{ filter: 'blur(3.8px)', userSelect: 'none' }}>
                <div className="modal-score-item">
                  <span className="modal-score-label">Score:</span>
                  <span className="modal-score-value">{TOTAL_CORRECT}/{TOTAL_MAX}</span>
                </div>
                <div className="modal-score-item">
                  <span className="modal-score-label">Accuracy:</span>
                  <span className="modal-score-value">{ACCURACY}%</span>
                </div>
                <div className="modal-score-item">
                  <span className="modal-score-label">Level:</span>
                  <span className="modal-score-value">{ENGLISH_LEVEL}</span>
                </div>
              </div>
            </div>

            <form onSubmit={handlePhoneSubmit} className="modal-form">
              <p className="modal-description">
                Всего один шаг до результата — введи номер!
              </p>

              <input
                type="tel"
                className="modal-input"
                placeholder="+7 700 700 70 70"
                value={phoneNumber}
                onChange={handlePhoneNumberChange}
                disabled={isSubmitting}
                required
              />

              {submitError && <div className="modal-error">{submitError}</div>}

              <button
                type="submit"
                className="btn modal-submit-btn"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Отправляется...' : 'Отправить'}
              </button>
            </form>
          </div>
        </div>
      )}
      <footer className="credit">
        <span>1english</span>
      </footer>
    </div>
  );
}
